import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UsersListLayer from "../components/UsersListLayer";

const UsersList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

       
        {/* TableDataLayer */}
        <UsersListLayer  />

      </MasterLayout>

    </>
  );
};

export default UsersList; 
